<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="rolesService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'users_roles.roles.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'users_roles.roles.roleRemoving' | translate }}
			<strong>{{ data.role.Name }}</strong>
		</p>
	</div>
</alaris-dialog>
